import React, { useRef, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';

export const useFileDropHook = (onUpload, extensions = []) => {

  const ref = useRef(null)
  const [drag, setDrag] = useState(false)

  const onDragOver = val => e => {
    e.preventDefault();
    setDrag(val);
  }

  const onDrop = e => {
    e.stopPropagation();
    e.preventDefault();
    onUpload(e.dataTransfer.files);
    setDrag(false);
  }

  const onChange = e => {
    const files = e.target.files
    onUpload(files)
  }

  const onClick = () => {
    ref.current.click()
  }

  const HiddenInput = () => (
    <input name={uuidv4()} type="file" multiple={true} style={{ display: 'none' }} onChange={onChange} ref={ref} />
  )

  const DropBox = props => (
    <div
      onDragEnter={onDragOver(true)}
      onDragLeave={onDragOver(false)}
      onDragOver={onDragOver(true)}
      onDrop={onDrop}
      {...props}
    >
      {props.children}
    </div>
  )
  
  return {
    DropBox,
    HiddenInput,
    onClick,
    drag,
  }
}
